export default {
  props: {
    isDark: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/close-button/close-button.js